function stringDateToJsonDate(stringDate) {
  if (stringDate.length !== 10) {
    return null;
  }
  if (stringDate.split('/').length !== 3) {
    return null;
  }
  const parts = stringDate.split('/');

  const year = parts[2];
  const month = parts[1];
  const day = parts[0];

  return `${year}-${month}-${day}T00:00:00.000Z`;
}

export default stringDateToJsonDate;
